export default __webpack_public_path__ + "static/media/mini-search.d282730f.png";